import {
  FormInput,
  Form,
  FormField,
  Button,
  useMultiStepForm,
} from "web-design-system";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useResetDistributorPassword, useUser } from "creso-core/hooks";

const formSchema = z
  .object({
    password: z.string().min(8),
    confirmPassword: z.string().min(8),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
  });

type FormValues = z.infer<typeof formSchema>;

export function CreatePasswordForm() {
  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  });
  const { nextStep } = useMultiStepForm<FormValues>();
  const { data: user } = useUser();
  const resetDistributorPassword = useResetDistributorPassword();
  const onSubmit = async (values: FormValues) => {
    if (!user) return;
    const results = await Promise.allSettled([
      resetDistributorPassword.mutateAsync({
        new_password: values.password,
      }),
    ]);
    if (results.every((result) => result.status === "fulfilled")) {
      nextStep();
    }
  };
  return (
    <div className="flex flex-col gap-5">
      <span className="text-lg font-semibold">Create password</span>
      <Form {...form}>
        <form
          className="flex flex-col size-full justify-between flex-1 gap-5"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <div className="flex flex-col gap-6 pb-8">
            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormInput
                  type="password"
                  label="Password"
                  {...field}
                  autoComplete="new-password"
                  className="gap-2"
                />
              )}
            />
            <FormField
              control={form.control}
              name="confirmPassword"
              render={({ field }) => (
                <FormInput
                  type="password"
                  label="Confirm Password"
                  {...field}
                  autoComplete="new-password"
                  className="gap-2"
                />
              )}
            />
          </div>
          <Button size="lg" className="w-full" type="submit">
            Continue
          </Button>
        </form>
      </Form>
    </div>
  );
}
